import { useEffect } from "react";

import { ScreenNameEnum } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";

export const usePostUserAccessScreenLogs = (screenName: ScreenNameEnum): void => {
  useEffect(() => {
    const logAccess = async () => {
      try {
        const fp = PropallyApiFactory();
        await fp.v1UserAccessScreenLogsPost({ screen_name: screenName }, { withCredentials: true });
      } catch {
        // 画面アクセス計測は失敗しても UI に影響しないため握りつぶす（セッション切れの 401 など）。
        // console.error / warn は Sentry の CaptureConsole に拾われるため使わない。
      }
    };

    logAccess();
  }, [screenName]);
};
